import {
  deleteAddressApiCall,
  getProviderAddressesApiCall,
  getUserAddressesApiCall,
  saveAddressApiCall,
  setDefaultAddressApiCall,
  updateAddressApiCall,
} from '@guryou/api-client-gql';

import { execute } from '../actions/actionWrapper';
import { Action, basicReducer } from '../core';

// Provider (deal) address management
export const PROVIDER_ADDRESSES = { entity: 'PROVIDER_ADDRESSES', action: Action.GET_MANY };
export const USER_ADDRESSES = { entity: 'USER_ADDRESSES', action: Action.GET_MANY };
export const SAVE_ADDRESS = { entity: 'SAVE_ADDRESS', action: Action.CREATE };
export const UPDATE_ADDRESS = { entity: 'UPDATE_ADDRESS', action: Action.UPDATE };
export const DELETE_ADDRESS = { entity: 'DELETE_ADDRESS', action: Action.DELETE };
export const SET_DEFAULT_ADDRESS = { entity: 'SET_DEFAULT_ADDRESS', action: Action.UPDATE };

export const getProviderAddresses =
  (silent = false) =>
  async dispatch =>
    execute(dispatch, () => getProviderAddressesApiCall(), PROVIDER_ADDRESSES, null, null, silent);

export const getUserAddresses =
  (silent = false) =>
  async dispatch =>
    execute(dispatch, () => getUserAddressesApiCall(), USER_ADDRESSES, null, null, silent);

export const saveAddress = input => async dispatch => execute(dispatch, () => saveAddressApiCall({ input }), SAVE_ADDRESS);

export const updateAddress = input => async dispatch => execute(dispatch, () => updateAddressApiCall({ input }), UPDATE_ADDRESS);

export const deleteAddress = id => async dispatch => execute(dispatch, () => deleteAddressApiCall({ id }), DELETE_ADDRESS);

export const setDefaultAddress = (id, ownerType, ownerId, type) => async dispatch =>
  execute(dispatch, () => setDefaultAddressApiCall({ id, ownerType, ownerId, type }), SET_DEFAULT_ADDRESS);

export const addressesReducer = {
  all: basicReducer(PROVIDER_ADDRESSES),
  userAll: basicReducer(USER_ADDRESSES),
  save: basicReducer(SAVE_ADDRESS),
  update: basicReducer(UPDATE_ADDRESS),
  delete: basicReducer(DELETE_ADDRESS),
  setDefault: basicReducer(SET_DEFAULT_ADDRESS),
};

// Customer (feel) address management
export const ADDRESSES_GET = { entity: 'USER_ADDRESSES', action: Action.GET_MANY };
export const ADDRESS_SAVE = { entity: 'ADDRESS', action: Action.CREATE };
export const ADDRESS_UPDATE = { entity: 'ADDRESS', action: Action.UPDATE };
export const ADDRESS_DELETE = { entity: 'ADDRESS', action: Action.ARCHIVE };
export const ADDRESS_SET_DEFAULT = { entity: 'ADDRESS_DEFAULT', action: Action.UPDATE };

export const getMyAddresses = () => async dispatch => execute(dispatch, () => getUserAddressesApiCall(), ADDRESSES_GET, false);

export const saveMyAddress = input => async dispatch => execute(dispatch, () => saveAddressApiCall({ input }), ADDRESS_SAVE, true);

export const updateMyAddress = input => async dispatch => execute(dispatch, () => updateAddressApiCall({ input }), ADDRESS_UPDATE, true);

export const deleteMyAddress = id => async dispatch => execute(dispatch, () => deleteAddressApiCall({ id }), ADDRESS_DELETE, true);

export const setMyDefaultAddress = (id, type) => async (dispatch, getState) => {
  const { auth } = getState();
  const ownerId = +(auth?.data?.userId || auth?.data?.sub || 0);
  execute(dispatch, () => setDefaultAddressApiCall({ id, ownerType: 'user', ownerId, type }), ADDRESS_SET_DEFAULT, true);
};

export const addressFeelReducers = {
  list: basicReducer(ADDRESSES_GET),
  save: basicReducer(ADDRESS_SAVE),
  update: basicReducer(ADDRESS_UPDATE),
  delete: basicReducer(ADDRESS_DELETE),
  setDefault: basicReducer(ADDRESS_SET_DEFAULT),
};
